import User from '@/user';
import user from "../../../../../js/user";

export default () => {
  $('.blog .blue-btn.mx-auto').on('click', function(){
    location.href = $(this).attr('data-href');
  });
};
